import { functionsIn } from 'lodash'
import util from '../util'

let controller = 'ContaTransitoria'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
    ComboTransitoria: function () {
        return util.Axios.Get(controller + '/ComboTransitoria')
    },
    AtualizarContaTransitoria: function(dto) {
      return util.Axios.Put(controller + '/AtualizarContaTransitoria', '', dto)
    },
    ListarOperacoesContaTransitoria: function (codigoConta) {
      return util.Axios.Get(controller + '/ListarOperacoesContaTransitoria/' + codigoConta)
    },
    PostContaTransitoria: function(dto) {
      return util.Axios.Post(controller + '/InserirTransitorias', dto)
    },
    GetTransitoriaByParceiro: function (dto) {
      return util.Axios.GetAll(controller + '/ListarTransitorias', dto)
    },
    ObterContasTransitoriasPorParceiro: function (codigoParceiro) {
      return util.Axios.Get(controller + "/parceiros", codigoParceiro)
    }
})
